import { createDataNode } from '../nodeFactory/dataNodeUtils'
import { fixOriginalFont, getFontColor, textThemeToOriginalFont } from '@wix/thunderbolt-becky-root'
import { ThemeData } from '@wix/thunderbolt-becky-types'
import { color as colorFunctions } from '@wix/thunderbolt-commons'

export const WFlatTheme = createDataNode({
	getDependencies: () => {},
	toViewItem: (item: ThemeData, __schemaDeps) => {
		const fonts = item.textTheme
			? item.textTheme.map((textTheme) => textThemeToOriginalFont(textTheme, { withColor: true }))
			: item.font

		const fixedFonts = fonts.map((font) => fixOriginalFont(font, true))

		const colorMap = item.color.reduce<{ [index: string]: string | null }>((acc, curr, i) => {
			acc[`color_${i}`] = colorFunctions.getHexColor(curr)
			return acc
		}, {})

		const fontMap = fixedFonts.reduce<{ [index: string]: string }>((acc, curr, i) => {
			acc[`font_${i}`] = curr
			return acc
		}, {})
		// TODO: add --theme-spx-ratio here

		const fontColorMap = fonts.reduce<{ [index: string]: string | undefined }>((acc, curr, i) => {
			acc[`font_${i}`] = getFontColor(curr)
			return acc
		}, {})

		return {
			...item,
			font: fixedFonts,
			colorMap,
			fontMap,
			fontColorMap,
		}
	},
})
